// extracted by mini-css-extract-plugin
export default {"blogImg":"BlogItem_blogImg__P4mNG","blog-content":"BlogItem_blog-content__3ACL+","text-overlay":"BlogItem_text-overlay__AYgFt","image-container":"BlogItem_image-container__tFKfv"};